import { useTranslation } from '@/hooks/useTranslation';
import React, { useState } from 'react';

interface SurveyHeaderProps {
  title: string;
  description?: string;
  progressPercent: number;
}

export const SurveyHeader: React.FC<SurveyHeaderProps> = ({
  title,
  description,
  progressPercent,
}) => {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className='survey-header-container'>
      {/* Header content */}
      <div className='survey-header-content'>
        <div className='flex items-start justify-between gap-4 mb-4'>
          <h1 className='text-2xl font-bold text-blue-700 flex-1'>{title}</h1>
          {description && (
            <button
              onClick={() => setIsExpanded(!isExpanded)}
              className='flex-shrink-0 p-1 hover:bg-gray-100 rounded transition-colors'
              aria-label={
                isExpanded
                  ? t('surveyHeader.collapseDescription')
                  : t('surveyHeader.expandDescription')
              }
            >
              <i
                className={`pi ${isExpanded ? 'pi-chevron-up' : 'pi-chevron-down'} text-gray-600 text-sm`}
                aria-hidden='true'
              />
            </button>
          )}
        </div>
        {isExpanded && description && (
          <p className='text-sm text-gray-600 leading-relaxed mb-4'>
            {description}
          </p>
        )}
      </div>

      {/* Progress bar at bottom - thicker with border style */}
      <div className='relative h-1.5 w-full bg-transparent border-b-2 border-blue-200'>
        <div
          className='absolute top-0 left-0 h-full bg-blue-700 transition-all duration-300 border-b-2 border-blue-700'
          style={{ width: `${progressPercent}%` }}
        />
      </div>
    </div>
  );
};
